import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type React from 'react';
import { strings } from 'strings';
import { z } from 'zod';

const AdmissionStartSchema = z.object({
  admissionId: z.string(),
  periodStart: z.string(),
});
export type AdmissionStartData = z.infer<typeof AdmissionStartSchema>;

export interface AdmissionStartProps {
  onChange?: (data: AdmissionStartData) => void;
}

const createFields = (): Field<AdmissionStartData>[] => {
  return [
    {
      subfields: [
        {
          key: 'periodStart',
          type: 'date-component',
          label: strings.AdmissionOnboardingLabel,
          maskType: 'date',
          validRange: { endDate: new Date() },
        },
      ],
    },
  ];
};

export const AdmissionStart: React.FC<AdmissionStartProps> = ({ onChange }) => {
  const fields = createFields();

  return (
    <CrudForm
      fields={fields}
      initialValues={{}}
      showSubmitButton={false}
      onChange={onChange}
      validationSchema={AdmissionStartSchema}
      cardProps={{ unsetZIndex: true }}
      hasCard={false}
      onChangeDebounceTime={0}
    />
  );
};
